import Enums from 'utils/EnumsManager';

const { REDUX_ACTION_TYPE_PREFIX } = Enums;
const { CONVERSION } = REDUX_ACTION_TYPE_PREFIX;

export const SET_ACCOUNT_ID = `${CONVERSION}_SET_ACCOUNT_ID`;
export const RESET = `${CONVERSION}_RESET`;



// WEBPACK FOOTER //
// ./src/views/Conversion/flow/actionTypes.js